import React from "react";
import { Helmet } from "react-helmet";
import Images from "../Components/Layout/Images";
import HomeContact from "../Components/Home/HomeContact";

const ImageGallery = () => {
  const baseUrl: string = `${process.env.REACT_APP_URL}`;
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Image Gallery</title>
        <link rel="canonical" href={baseUrl + "/gallery"} />
      </Helmet>
      <div miw-280>
        <div className="bg-image-gallery h-100 flex-col-stretch p-15" style={{justifyContent: 'center'}}>
            <h1>Tangled Lead Fence and Welding Gallery</h1>
        </div>
        <div className="flex-col-stretch h-50 fs-15 fw-500 p-15" style={{justifyContent: 'center'}}>
            <span className="text-color-goldenrod">Pictures of Tangled Lead Fencing and Welding work. Click on an individual photo to enlarge.</span>
        </div>
        <Images />
      </div>
      <div className="bg-image">
        <HomeContact />
      </div>
    </div>
  );
};
export default ImageGallery;
